import { useEffect } from 'react';

// Utils
import { deselectAllCompareProducts } from '@/utils/Common/ListingUtils';

// Context
import { useCompareContext } from '@/context/compare';

export default () => {
  const [{ materialGroup }] = useCompareContext();

  useEffect(() => {
    if (!materialGroup) {
      deselectAllCompareProducts();
    }
  }, [materialGroup]);
};
